import { useTranslation } from "react-i18next";
import type {
  Assets,
  AttributeSchema,
  ImageAttributeValue,
} from "../../../../../../types/types.PIM";
import { RadioButtonContainer } from "../../../../../../layout/FormLayout";
import { RadioButton } from "../../../../../../components/RadioButton/RadioButton";
import { useState } from "react";
import {
  H6,
  SoftHeader,
} from "../../../../../../components/Typography/Typography";
import { ExistingImageAttribute } from "./ExistingImageAttributes";
import { NewImageAttributeForm } from "./NewImageAttributeForm";
import { FormProvider, useForm } from "react-hook-form";
import { spacingTokens } from "../../../../../../designTokens";

export const AddOrEditImageAttribute = ({
  attribute,
  onComplete,
  onCancel,
  existing_asset,
  image_attribute_value,
}: {
  attribute: AttributeSchema;
  onComplete: (image_attr: ImageAttributeValue | null) => void;
  onCancel: () => void;
  existing_asset?: Assets;
  image_attribute_value?: ImageAttributeValue;
}) => {
  const [is_existing_media, set_is_existing_media] = useState<boolean>(true);
  const { t } = useTranslation();

  const use_form = useForm();

  const handle_radio_change = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    if (value === "search" && checked) {
      set_is_existing_media(true);
    } else if (value === "upload" && checked) {
      set_is_existing_media(false);
    }
  };

  return (
    <>
      <SoftHeader>{t("Attribute Name")}</SoftHeader>
      <H6 style={{ marginBottom: spacingTokens.spacing_3xl }}>
        {attribute.name}
      </H6>
      <RadioButtonContainer>
        <RadioButton
          name="media"
          value="search"
          optionTitle={t(`Search from existing media`)}
          handleChange={handle_radio_change}
          checked={is_existing_media}
        />
        <RadioButton
          name="media"
          value="upload"
          optionTitle={t(`Upload new media`)}
          handleChange={handle_radio_change}
          checked={!is_existing_media}
        />
      </RadioButtonContainer>
      <FormProvider {...use_form}>
        {is_existing_media ? (
          <ExistingImageAttribute
            attribute={attribute}
            onComplete={onComplete}
            onCancel={onCancel}
            existing_asset={existing_asset}
            image_attribute_value={image_attribute_value}
          />
        ) : (
          <NewImageAttributeForm
            attribute={attribute}
            onComplete={onComplete}
            onCancel={onCancel}
          />
        )}
      </FormProvider>
    </>
  );
};
